export class CandidateCardQueryFilter {
    constructor(companyId, userId) {
        this.parentCompanyId = companyId;
        this.loggedInUserId = userId;
        this.status = [];
        this.roleList = [];
        this.recruiterList = [];
        this.requisitionNumbers = [];
        this.clientOrBuList = [];
        this.requisitionStatus = [];
        this.workflowStates = [];
        this.vendorIds = [];
        this.candidateType = "OWN_CANDIDATES";
    }
}
//# sourceMappingURL=candidateCardQueryFilter.js.map